/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useContext, useEffect, useRef } from "react";
import type { ChangeEventHandler } from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import {
  Button,
  Card,
  CardContent,
  Combobox,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbSeparator,
  BreadcrumbPage,
  Textarea,
  DatePicker,
  Input,
  DialogTrigger,
} from "@repo/ui";

import {
  useGetRouteServices,
  useGetStoreRecords,
  useIssueVan,
  useReturnVan,
  useIssueVanBulk,
  useReturnVanBulk,
  useGetDispatchTemplate,
  useGetReturnTemplate,
  useExportRosters,
  useGetRostersByData,
} from "utils/apis/store.api";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { showToast } from "utils/helper";
import Layout from "components/layout";
import {
  useGetAllFiledTeams,
  useGetCashCenters,
  useGetRegions,
  useGetVehicles,
} from "utils/apis/lookups.api";
import { Link } from "react-router-dom";
import { PREV_DAY_DATE } from "utils/constant";
import { UserContext } from "../../utils/reducers/user";
import { format as formatDate } from "date-fns";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-expect-error
import { ExcelRenderer } from "react-excel-renderer";
import { DateTimePicker } from "@progress/kendo-react-dateinputs";
import { Car, Edit, Users } from "lucide-react";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { FaFileExcel } from "react-icons/fa";
import { process } from "@progress/kendo-data-query";
import moment from "moment";
import EditRoster from "./edit-roster";
import { useSwapRostersTeam } from "utils/apis/split-route.api";
import KanbanBoard from "./kanban-board";

const statusList = [
  { id: "Dispatched", text: "Dispatched" },
  { id: "Returned", text: "Returned" },
];
const exportRoutesListKeys = [
  "routeNo",
  "region",
  "routeArea",
  "routeType",
  "cashCenter",
  "description",
  "busTime",
  "routeTime",
  "vanRegistrationNo",
  "cashBoxSerial",
  "hhtSerial",
  "printerSerial",
  "driverId",
  "driverName",
  "driverDesignation",
  "driverRegulatoryID",
  "driverContact",
  "driverNationality",
  "teamLeaderId",
  "teamLeaderName",
  "teamLeaderDesignation",
  "teamLeaderRegulatoryID",
  "teamLeaderContact",
  "teamLeaderNationality",
  "guard1Id",
  "guard1Name",
  "guard1Designation",
  "guard1RegulatoryID",
  "guard1Contact",
  "guard1Nationality",
  "guard2Id",
  "guard2Name",
  "guard2Designation",
  "guard2RegulatoryID",
  "guard2Contact",
  "guard2Nationality",
  "guard3Id",
  "guard3Name",
  "guard3Designation",
  "guard3RegulatoryID",
  "guard3Contact",
  "guard3Nationality",
  "status",
  "requestedBy",
  "remarks",
];
function excelToJSDate(excelDate: any) {
  if (typeof excelDate === "string" || excelDate instanceof String) {
    const parsedDate = Date.parse(excelDate as string);
    return new Date(parsedDate);
  }
  // Handle both date-only and date-time values
  const days = Math.floor(excelDate);
  const time = excelDate - days;

  // Excel's epoch adjustment
  const excelEpoch = new Date(1900, 0, 1);

  // Adjust for Excel's leap year bug (Feb 29, 1900 doesn't exist)
  const adjustedDays = days - (days > 60 ? 1 : 0) - 1;

  const date = new Date(excelEpoch.getTime() + adjustedDays * 86400000);

  // Add time component
  if (time > 0) {
    const milliseconds = time * 84120000;
    date.setTime(date.getTime() + milliseconds);
  }

  return date;
}

export default function StoreManagement() {
  const { CashCenterId, Roles } = useContext(UserContext);
  const vehicleUploadList = useRef<any[]>([]);
  const currentDate = new Date();

  let excelExport2: ExcelExport | null;

  let excelExportReturn: ExcelExport | null;

  const [operationDate, setOperationDate] = useState<Date>(currentDate);
  const [teams, setTeams] = useState<any[]>([]);
  const [team, setTeam] = useState<any>(null);

  // bulk upload dialog
  const [openFileUpload, setOpenFileUpload] = useState(false);
  const [uploadMode, setUploadMode] = useState<"issue" | "return">("issue");
  const [uploadedVehicles, setUploadedVehicles] = useState<any[]>([]);
  const [handoverDateTime, setHandoverDateTime] = useState<Date>(currentDate);
  const [busDateTime, setBusDateTime] = useState<Date>(currentDate);
  const [returnDateTime, setReturnDateTime] = useState<Date>(currentDate);
  const [startKilometer, setStartKilometer] = useState<number>(0);
  const [remarks, setRemarks] = useState<string>("");

  const [swapRouteA, setSwapRouteA] = useState<string>("");
  const [showSwapDialogue, setShowSwapDialogue] = useState<boolean>(false);
  const [swapRouteB, setSwapRouteB] = useState<string>("");

  const [totalTeams, setTotalTeams] = useState(0);
  const [inQueueTeams, setInQueueTeams] = useState(0);
  // eslint-disable-next-line react/hook-use-state
  const [dispatechedTeams, setDispatchedTeams] = useState(0);
  const [returnedTeams, setReturnedTeams] = useState(0);

  const [ddlVehicles, setDdlVehicles] = useState<string>("");
  const [currentStatus, setCurrentStatus] = useState<string>("");
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [selectedRegion, setSelectedRegion] = useState("");
  const [selectedCashCenter, setSelectedCashCenter] = useState(CashCenterId);
  const [filter, setFilter] = useState("");
  const [isVehicleUpdate, setIsVehicleUpdate] = useState<boolean>(false);
  const [exportRoutesList, setExportRoutesList] = useState<any>(null);

  const [dataState, setDataState] = useState<any>({});
  const [btnUpdateRecordDisabled, setBtnUpdateRecordDisabled] = useState(false);
  const [btnUpdateRecordText, setBtnUpdateRecordText] =
    useState("Update Record");
  const [visible, setVisible] = useState(false);
  const [ddlStatus, setDdlStatus] = useState<string>("");
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedRoute, setSelectedRoute] = useState(null);
  const pageSize = 25;
  const _rostersExport = React.createRef<ExcelExport | null>();
  const _swapColumnsRef = React.createRef();

  const { data: vehicles } = useGetVehicles(CashCenterId);
  const { data: cashCenters } = useGetCashCenters();
  const { data: regions } = useGetRegions("UAE");

  const { data: users } = useGetAllFiledTeams(selectedCashCenter);
  const {
    mutate: exportRosters,
    data: exportRosterRes,
    isPending: gettingRosterExport,
    reset: resetRosterExport,
  } = useExportRosters();
  const {
    mutate: getDispatchTemplate,
    isPending: dispatchTemplateLoading,
    data: dispatchTemplateData,
  } = useGetDispatchTemplate();
  const {
    mutateAsync: getReturnTemplate,
    isPending: returnTemplateLoading,
    data: ReturnData,
  } = useGetReturnTemplate();

  const { data: routesToSwap, refetch: refetchSwapRosters } =
    useGetRostersByData(
      selectedCashCenter,
      formatDate(operationDate || currentDate, "yyyy-MM-dd'T'00:00:00.000'Z'"),
    );
  const {
    mutate: swapRosterTeam,
    isPending: swappingRouteTeam,
    isSuccess: isSwapSuccessful,
    reset: resetSwapRosters,
  } = useSwapRostersTeam();

  const {
    data: teamsData,
    isSuccess: storeRecordSuccess,
    isError: storeRecordError,
    refetch: refetchRosters,
    isFetching: loadingRequests,
  } = useGetStoreRecords({
    cashCenterId: CashCenterId,
    operationDate: formatDate(
      operationDate || currentDate,
      "yyyy-MM-dd'T'00:00:00.000'Z'",
    ),
    pageNumber: currentPage,
    pageRowCount: pageSize,
    region: selectedRegion,
    searchCriteria: filter,
  });

  const refetchData = async () => {
    resetSwapRosters();
    await refetchRosters();
    await refetchSwapRosters();
  };
  useEffect(() => {
    if (storeRecordSuccess) {
      const _teams = teamsData.data;
      setTeams(_teams);
      setTotalTeams(_teams.length);
      setInQueueTeams(
        _teams.filter((rl: any) => rl.status == "In Queue").length,
      );
      setDispatchedTeams(
        _teams.filter((rl: any) => rl.status == "Dispatched").length,
      );
      setReturnedTeams(
        _teams.filter((rl: any) => rl.status == "Returned").length,
      );
    }
    if (storeRecordError) {
      setTotalTeams(0);
      setInQueueTeams(0);
      setDispatchedTeams(0);
      setReturnedTeams(0);
      setTeams([]);
    }
    if (exportRoutesList) {
      excelExportRosters();
      setExportRoutesList(null);
    }

    if (exportRosterRes) {
      const list = exportRosterRes.map((item: any) => ({
        ...item,
        busTime: item.busTime
          ? moment(item.busTime, "YYYY-MM-DD HH:mm:ss").format("HH:mm")
          : "",
        routeTime: item.routeTime
          ? moment(item.routeTime, "YYYY-MM-DD HH:mm:ss").format("HH:mm")
          : "",
        vanHandoverTime: item.vanHandoverTime
          ? moment(item.vanHandoverTime, "YYYY-MM-DD HH:mm:ss").format("HH:mm")
          : "",
        vanReturnedTime: item.vanReturnedTime
          ? moment(item.vanReturnedTime, "YYYY-MM-DD HH:mm:ss").format("HH:mm")
          : "",
        // Driver Mapping (with Optional Chaining '?.' to prevent errors if null)
        driverId: item.driver?.employeeId || null,
        driverName: item.driver?.name || null,
        driverRegulatoryID: item.driver?.regulatoryId ?? null,
        driverNationality: item.driver?.nationality ?? null,

        // Team Leader Mapping
        teamLeaderId: item.teamLeader?.employeeId || null,
        teamLeaderName: item.teamLeader?.name || null,
        teamLeaderRegulatoryID: item.teamLeader?.regulatoryId ?? null,
        teamLeaderNationality: item.teamLeader?.nationality ?? null,

        // Guard 1 Mapping
        guard1Id: item.guard1?.employeeId || null,
        guard1Name: item.guard1?.name || null,
        guard1RegulatoryID: item.guard1?.regulatoryId ?? null,
        guard1Nationality: item.guard1?.nationality ?? null,

        // Guard 2 Mapping
        guard2Id: item.guard2?.employeeId || null,
        guard2Name: item.guard2?.name || null,
        guard2RegulatoryID: item.guard2?.regulatoryId ?? null,
        guard2Nationality: item.guard2?.nationality ?? null,

        // Guard 3 Mapping
        guard3Id: item.guard3?.employeeId || null,
        guard3Name: item.guard3?.name || null,
        guard3RegulatoryID: item.guard3?.regulatoryId ?? null,
        guard3Nationality: item.guard3?.nationality ?? null,
      }));
      setExportRoutesList(list);
      resetRosterExport();
    }
    if (isSwapSuccessful) {
      refetchData();
      resetSwapRosters();
      setSwapRouteA("");
      setSwapRouteB("");
      setShowSwapDialogue(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    storeRecordSuccess,
    storeRecordError,
    teamsData,
    exportRoutesList,
    exportRosterRes,
    isSwapSuccessful,
  ]);

  const excelExportRosters = () => {
    if (_rostersExport.current) {
      _rostersExport.current?.save();
    }
  };
  useEffect(() => {
    if (dispatchTemplateData) {
      excelExport2?.save(dispatchTemplateData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatchTemplateData]);

  useEffect(() => {
    if (ReturnData) {
      excelExportReturn?.save(ReturnData);
      // setDownloadingReturn(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ReturnData]);

  const {
    isSuccess: serviceSuccess,
    isError: serviceError,
    data: routeServiceData,
  } = useGetRouteServices();

  useEffect(() => {
    if (serviceSuccess && routeServiceData && teams) {
      const data = teams.slice();
      setTeams([...data]);
    }
    if (serviceError && teams) {
      const data = teams.slice();
      setTeams([...data]);
      showToast("error", "No open services found.");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serviceSuccess, serviceError]);

  const onTxtHandoverDateChanged = (value: Date | null) => {
    if (!value) return;
    if (value < PREV_DAY_DATE) {
      showToast(
        "error",
        "Unable to set handover date earlier than previous day.",
      );
      setHandoverDateTime(PREV_DAY_DATE);
      return;
    }
    if (value > currentDate) {
      showToast("error", "Unable to set handover date in future.");
      setHandoverDateTime(currentDate);
      return;
    }
    setHandoverDateTime(value);
  };

  const onTxtBusDateChanged = (value: Date | null) => {
    if (!value) return;
    if (value < PREV_DAY_DATE) {
      showToast("error", "Unable to set bus date earlier than previous day.");
      setBusDateTime(PREV_DAY_DATE);
      return;
    }
    if (value > currentDate) {
      showToast("error", "Unable to set bus date in future.");
      setBusDateTime(currentDate);
      return;
    }
    setBusDateTime(value);
  };

  const onTxtReturnDateChanged = (value: Date | null) => {
    if (!value) return;
    if (value < PREV_DAY_DATE) {
      showToast(
        "error",
        "Unable to set return date earlier than previous day.",
      );
      setReturnDateTime(PREV_DAY_DATE);
      return;
    }
    if (value > currentDate) {
      showToast("error", "Unable to set return date in future.");
      setReturnDateTime(currentDate);
      return;
    }
    setReturnDateTime(value);
  };

  const fileHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const fileObj = event.target.files?.[0];
    if (!fileObj) return;
    const supportedTypes = [
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "text/csv",
    ];
    if (!supportedTypes.includes(fileObj.type)) {
      event.target.value = "";
      return showToast("error", "Failed to parse file.");
    }
    ExcelRenderer(fileObj, (err: any, resp: any) => {
      if (err) {
        event.target.value = "";
        return showToast("error", "Failed to parse file.");
      }
      const rows = resp.rows || [];
      if (rows.length <= 1) {
        showToast("error", "No data found in file.");
        event.target.value = "";
        return;
      }
      const parsedVehicles: any[] = [];
      for (let i = 1; i < rows.length; i++) {
        const row = rows[i];
        if (
          !row ||
          row.every(
            (cell: any) => cell === null || cell === undefined || cell === "",
          )
        ) {
          continue;
        }
        if (uploadMode === "issue") {
          const [
            rosterId,
            routeNo,
            vanRegistrationNo,
            vanHandoverTime,
            startKilometer,
            remark,
          ] = row;
          if (vanRegistrationNo && routeNo) {
            parsedVehicles.push({
              rosterId: String(rosterId ?? "").trim(),
              routeNo: String(routeNo ?? "").trim(),
              vanRegistrationNo: String(vanRegistrationNo ?? "").trim(),
              startKilometer: Number(startKilometer ?? 0),
              vanHandoverTime: formatDate(
                excelToJSDate(vanHandoverTime),
                "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'",
              ),
              remarks: String(remark ?? "").trim(),
            });
          }
        } else {
          const [
            rosterId,
            routeNo,
            vanRegistrationNo,
            endKilometer,
            returnDateTimeExcel,
            remark,
          ] = row;
          if (vanRegistrationNo) {
            parsedVehicles.push({
              rosterId: String(rosterId ?? "").trim(),
              routeNo: String(routeNo ?? "").trim(),
              shift: "morning",
              vanRegistrationNo: String(vanRegistrationNo ?? "").trim(),
              remarks: String(remark ?? "").trim(),
              endKilometer: Number(endKilometer ?? 0),
              returnDateTime: formatDate(
                excelToJSDate(returnDateTimeExcel),
                "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'",
              ),
            });
          }
        }
      }
      if (parsedVehicles.length > 0) {
        showToast("success", "File uploaded successfully!");
        setUploadedVehicles(parsedVehicles);
        vehicleUploadList.current = parsedVehicles;
      } else {
        showToast("error", "No valid data found in Excel file.");
      }
      event.target.value = "";
    });
  };

  // --- bulk mutations ---
  const {
    mutate: issueVanBulk,
    isPending: issueVanBulkLoading,
    isSuccess: issueVanBulkSuccess,
  } = useIssueVanBulk();
  const {
    mutate: returnVanBulk,
    isPending: returnVanBulkLoading,
    isSuccess: returnVanBulkSuccess,
  } = useReturnVanBulk();

  const onConfirmVehicleUpload = () => {
    if (!uploadedVehicles.length) {
      return showToast(
        "error",
        "No vehicles to process. Please upload a valid Excel file.",
      );
    }
    if (uploadMode === "issue") {
      issueVanBulk({
        operationDate: formatDate(
          operationDate,
          "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'",
        ),
        vans: uploadedVehicles,
      });
    } else {
      returnVanBulk({
        operationDate: formatDate(
          operationDate,
          "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'",
        ),
        vans: uploadedVehicles,
      });
    }
  };

  // const { mutate: updateVanStatus, isSuccess: updateSuccess, isError: updateError } = useUpdateVanStatus();
  const {
    mutate: issueVan,
    isSuccess: issueVanSuccess,
    isError: issueVanError,
  } = useIssueVan(isVehicleUpdate);
  const {
    mutate: returnVan,
    isSuccess: returnVanSuccess,
    isError: returnVanError,
  } = useReturnVan();

  const toggleDialog = (type?: string) => {
    setVisible(!visible);
    setIsVehicleUpdate(type === "vehicle");
  };

  function EditButtonCell({ dataItem }: any) {
    const onClick = (type: string) => {
      setTeam(dataItem);
      setCurrentStatus(dataItem.status);
      if (dataItem.status) setDdlStatus(dataItem.status);
      if (dataItem.vanRegistrationNo)
        setDdlVehicles(dataItem.vanRegistrationNo);
      setBtnUpdateRecordDisabled(false);
      toggleDialog(type);
    };

    return (
      <td className="text-center flex justify-center gap-2">
        <Button
          disabled={dataItem.status !== "Dispatched"}
          variant="secondary"
          onClick={() => {
            onClick("vehicle");
          }}
          size="sm"
        >
          <Car size="16" className="mr-1" /> Vehicle
        </Button>
        <Button
          disabled={dataItem.status === "Returned"}
          variant="secondary"
          onClick={() => {
            onClick("status");
          }}
          size="sm"
        >
          <Edit size="16" className="mr-1" /> Status
        </Button>
      </td>
    );
  }

  const onOperationDateChanged = (value: Date) => {
    setOperationDate(value);
  };

  const onBtnUpdateRecordClicked = () => {
    if (!team) return;
    if (!ddlStatus) {
      showToast("error", "Please select status");
      return;
    }
    if (ddlStatus === "Dispatched") {
      if (!ddlVehicles) {
        showToast("error", "Please select vehicle");
        return;
      }
      if (operationDate > currentDate && !isVehicleUpdate) {
        showToast("error", "Unable to dispatch vehicle in future date.");
        return;
      }
      if (operationDate < PREV_DAY_DATE && !isVehicleUpdate) {
        showToast("error", "Unable to dispatch vehicle in previous date.");
        return;
      }
      const issueVanDto = {
        rosterId: team.rosterId,
        vanRegistrationNo: ddlVehicles,
        startKilometer:
          (isVehicleUpdate ? team.startKilometer : startKilometer) || 0,
        vanHandoverTime: formatDate(
          (isVehicleUpdate
            ? new Date(team.vanHandoverTime)
            : handoverDateTime) || currentDate,
          "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'",
        ),
        busTime: formatDate(
          (isVehicleUpdate ? new Date(team.busTime) : busDateTime) ||
            currentDate,
          "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'",
        ),
        remarks,
        routeNo: team.routeNo,
      };
      setBtnUpdateRecordDisabled(true);
      setBtnUpdateRecordText("Issuing Van...");
      issueVan(issueVanDto);
    } else if (ddlStatus === "Returned") {
      if (!team.rosterId) {
        showToast("error", "No store record found.");
        return;
      }
      const returnVanDto = {
        rosterId: team.rosterId,
        vanRegistrationNo: team.vanRegistrationNo,
        returnDateTime: formatDate(
          returnDateTime || currentDate,
          "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'",
        ),
        endKilometer: team.endKilometer || 0,
        remarks,
      };
      setBtnUpdateRecordDisabled(true);
      setBtnUpdateRecordText("Returning Van...");
      returnVan(returnVanDto);
    }
  };

  useEffect(() => {
    if (returnVanSuccess) {
      setDdlVehicles("");
      setDdlStatus("");
      setReturnDateTime(currentDate);
      setBtnUpdateRecordText("Update Record");
      showToast("success", "Van returned successfully!");
      toggleDialog();
      setCurrentStatus("");
    }
    if (returnVanError) {
      showToast(
        "error",
        "Failed to confirm return van, please try again later.",
      );
      setBtnUpdateRecordDisabled(false);
      setBtnUpdateRecordText("Return Van");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [returnVanSuccess, returnVanError]);

  useEffect(() => {
    if (issueVanSuccess) {
      setDdlVehicles("");
      setDdlStatus("");
      setHandoverDateTime(currentDate);
      setBtnUpdateRecordText("Update Record");
      toggleDialog();
      setCurrentStatus("");
    }
    if (issueVanError) {
      setBtnUpdateRecordDisabled(false);
      setBtnUpdateRecordText("Update Record");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [issueVanSuccess, issueVanError]);

  useEffect(() => {
    if (issueVanBulkSuccess || returnVanBulkSuccess) {
      setOpenFileUpload(false);
    }
  }, [issueVanBulkSuccess, returnVanBulkSuccess]);
  // --- render ---
  const onFilterChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    setFilter(event.target.value);
  };
  const onPageChange = (e: any) => {
    const _page = e.page.skip / pageSize + 1;
    setCurrentPage(_page);
  };
  const viewTeamCell = ({ dataItem }: any) => (
    <td className="k-table-td">
      <div className="flex flex-row items-center justify-center w-full">
        <Dialog>
          <DialogTrigger>
            <div className="cursor-pointer">
              <Users />
            </div>
          </DialogTrigger>
          <DialogContent className="max-w-[60vw] w-full">
            <DialogHeader>
              <DialogTitle>Field Team</DialogTitle>
            </DialogHeader>
            <div className="flex flex-row flex-wrap gap-[16px] w-full">
              {" "}
              {dataItem.fieldTeam.map((elm: any) => {
                return (
                  <Card
                    style={{ width: `calc(50% - 8px)` }}
                    key={`${elm.role}-${elm.name}`}
                  >
                    <CardContent className="p-4">
                      <div className="flex flex-row justify-between">
                        <p style={{ fontWeight: 500 }}> Name</p>
                        <p className="ml-auto">{elm.name}</p>
                      </div>
                      <div className="border-b my-2 bg-accent" />
                      <div className="flex flex-row justify-between gap-4">
                        <p style={{ fontWeight: 500 }}> Employee ID</p>
                        <p className="ml-auto">{elm.employeeId}</p>
                      </div>
                      <div className="border-b my-2 bg-accent" />
                      <div className="flex flex-row justify-between gap-4">
                        <p style={{ fontWeight: 500 }}> Regulatory ID </p>
                        <p className="ml-auto">{elm.regulatoryId}</p>
                      </div>
                      <div className="border-b my-2 bg-accent" />
                      <div className="flex flex-row justify-between gap-4">
                        <p style={{ fontWeight: 500 }}> Role </p>
                        <p className="ml-auto">{elm.role}</p>
                      </div>
                      <div className="border-b my-2 bg-accent" />
                      <div className="flex flex-row justify-between gap-4">
                        <p style={{ fontWeight: 500 }}> Nationality</p>
                        <p className="ml-auto">{elm.nationality}</p>
                      </div>
                    </CardContent>
                  </Card>
                );
              })}
            </div>
            {/* 
            <div className="flex flex-row gap-8">
              <p style={{ fontWeight: 500, width: "100%", textWrap: "nowrap" }}>
                Route No: {dataItem.routeNo}
              </p>
              <p style={{ fontWeight: 500, width: "100%", textWrap: "nowrap" }}>
                Route Type: {dataItem.routeType}
              </p>
              <p style={{ fontWeight: 500, width: "100%", textWrap: "nowrap" }}>
                Area: {dataItem.area}
              </p>
              <p style={{ fontWeight: 500, width: "100%", textWrap: "nowrap" }}>
                Region: {dataItem.region}
              </p>
            </div> */}
          </DialogContent>
        </Dialog>
      </div>
    </td>
  );
  const editCell = ({ dataItem }: any) => (
    <td className="k-table-td">
      <div
        className="flex justify-center w-full cursor-pointer"
        title="Edit Consumables"
        style={
          dataItem?.status !== "Returned" ? { textDecoration: "underline" } : {}
        }
        onClick={() => {
          if (dataItem?.status !== "Returned") {
            setOpenEditModal(true);
            setSelectedRoute(dataItem);
          }
        }}
      >
        {dataItem.routeNo}
      </div>
    </td>
  );

  const mergedTeam = (_swapRouteA: string, _swapRouteB: string) => {
    const mergedTeamMembers = [];
    let swapRouteATeam = [];
    let swapRouteBTeam = [];
    if (_swapRouteB) {
      swapRouteBTeam = JSON.parse(_swapRouteB).fieldTeam;
    }
    if (_swapRouteA) {
      swapRouteATeam = JSON.parse(_swapRouteA).fieldTeam;
    }
    if (swapRouteATeam?.length && swapRouteBTeam?.length) {
      while (swapRouteATeam?.length) {
        const memberA = swapRouteATeam.shift();
        const memberB = swapRouteBTeam.find(
          (elm: any) => elm.role === memberA.role,
        );
        if (memberB) {
          const merged = [
            { ...JSON.parse(_swapRouteA), ...memberA },
            { ...JSON.parse(_swapRouteB), ...memberB },
          ];
          mergedTeamMembers.push(merged);
        }
      }
    }
  };

  const onTeamSwap = () => {
    const _swappedTeams: any = _swapColumnsRef.current;
    let routeA: any = {};
    let routeB: any = {};
    if (swapRouteA) {
      routeA = JSON.parse(swapRouteA);
    }
    if (routeB) {
      routeB = JSON.parse(swapRouteB);
    }

    const payload = {
      firstObjId: routeA.rosterId,
      secondObjId: routeB.rosterId,
      firstTeam: _swappedTeams.routeA.map((elm: any) => ({
        employeeId: elm.employeeId,
        regulatoryId: elm.regulatoryId,
        name: elm.name,
        role: elm.role,
        nationality: elm.nationality,
      })),
      secondTeam: _swappedTeams.routeB.map((elm: any) => ({
        employeeId: elm.employeeId,
        regulatoryId: elm.regulatoryId,
        name: elm.name,
        role: elm.role,
        nationality: elm.nationality,
      })),
    };
    swapRosterTeam(payload);
  };
  const routeListExportKeys = React.useMemo(() => {
    const _keys: any = [];
    if (exportRoutesList) {
      const dataKeys = Object.keys(exportRoutesList[0]);
      exportRoutesListKeys.forEach((key) => {
        if (dataKeys.includes(key)) {
          _keys.push(key);
        }
      });
    }

    return _keys;
  }, [exportRoutesList]);
  return (
    <Layout>
      <Breadcrumb className="mt-5 mx-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link to="/dashboard">Home</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Field Team Trips</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>

      <Card className="mx-4 mt-5">
        <CardContent className="pt-6">
          <div className="flex gap-2 mb-5">
            <Card className="w-[calc(100%/4)]">
              <CardContent className="text-center pt-6">
                <strong className="text-lg text-primary">Total Teams</strong>
                <span className="text-xl block text-secondary">
                  {totalTeams}
                </span>
              </CardContent>
            </Card>
            <Card className="w-[calc(100%/4)]">
              <CardContent className="text-center pt-6">
                <strong className="text-lg text-primary">In Queue</strong>
                <span className="text-xl block text-secondary">
                  {inQueueTeams}
                </span>
              </CardContent>
            </Card>
            <Card className="w-[calc(100%/4)]">
              <CardContent className="text-center pt-6">
                <strong className="text-lg text-primary">Dispatched</strong>
                <span className="text-xl block text-secondary">
                  {dispatechedTeams}
                </span>
              </CardContent>
            </Card>
            <Card className="w-[calc(100%/4)]">
              <CardContent className="text-center pt-6">
                <strong className="text-lg text-primary">Returned</strong>
                <span className="text-xl block text-secondary">
                  {returnedTeams}
                </span>
              </CardContent>
            </Card>
          </div>
          <div className="flex justify-between items-center gap-4 mb-5">
            <div className="flex gap-2">
              <Button
                variant="secondary"
                onClick={() => {
                  getDispatchTemplate(
                    formatDate(
                      operationDate || currentDate,
                      "yyyy-MM-dd'T'00:00:00.000'Z'",
                    ),
                  );
                }}
                disabled={dispatchTemplateLoading}
              >
                {dispatchTemplateLoading
                  ? "Downloading..."
                  : "Download Dispatch Template"}
              </Button>
              <Button
                variant="secondary"
                onClick={() => {
                  setUploadMode("issue");
                  setUploadedVehicles([]);
                  setOpenFileUpload(true);
                }}
              >
                Issue Vehicle In Bulk
              </Button>
              <Button
                variant="secondary"
                onClick={() => {
                  getReturnTemplate(
                    formatDate(
                      operationDate || currentDate,
                      "yyyy-MM-dd'T'00:00:00.000'Z'",
                    ),
                  );
                }}
                disabled={returnTemplateLoading}
              >
                {returnTemplateLoading
                  ? "Downloading..."
                  : "Download Return Template"}
              </Button>
              <Button
                variant="secondary"
                onClick={() => {
                  setUploadMode("return");
                  setUploadedVehicles([]);
                  setOpenFileUpload(true);
                }}
              >
                Return Vehicle In Bulk
              </Button>
            </div>

            <div className="flex gap-4 items-center w-[30%] justify-end">
              {/* <div className={`text-end ${loaderPanel}`}>
                <Loader size="large" type="pulsing" />
              </div> */}

              <Dialog
                open={showSwapDialogue}
                onOpenChange={(e) => {
                  setSwapRouteA("");
                  setSwapRouteB("");
                  setShowSwapDialogue(e);
                }}
              >
                <DialogTrigger>
                  <Button
                    variant="secondary"
                    disabled={
                      !(
                        Roles.includes("Operations Supervisor") ||
                        Roles.includes("PA Assistant") ||
                        Roles.includes("PA Supervisor")
                      )
                    }
                    onClick={() => {
                      setShowSwapDialogue(true);
                    }}
                  >
                    Swap Roster
                  </Button>
                </DialogTrigger>

                <DialogContent
                  className="max-w-[100vw] w-full h-[90vh] overflow-scroll"
                  onInteractOutside={(e: any) => e.preventDefault()}
                  onEscapeKeyDown={(e: any) => e.preventDefault()}
                >
                  <DialogHeader>
                    <DialogTitle>Swap Team</DialogTitle>
                    <DialogDescription>
                      <div className="flex flex-row items-center justify-between w-full mb-2">
                        <p> Swap team members between rosters</p>
                        <Button
                          variant="secondary"
                          onClick={onTeamSwap}
                          disabled={
                            !(swapRouteA && swapRouteA !== swapRouteB) ||
                            swappingRouteTeam
                          }
                        >
                          Save
                        </Button>
                      </div>

                      {swapRouteA && swapRouteA === swapRouteB ? (
                        <p className="pt-6 text-sm text-red-500">
                          Both rosters can not be same
                        </p>
                      ) : null}

                      <div className="flex flex-row items-start justify-start">
                        <div className="flex flex-col w-[48.5%]">
                          <p style={{ fontWeight: 500, marginBottom: "8px" }}>
                            Route 1
                          </p>
                          <Combobox
                            setValue={(e: string) => {
                              setSwapRouteA(e);
                              mergedTeam(e, swapRouteB);
                            }}
                            value={swapRouteA}
                            placeholder="Select Route"
                            data={routesToSwap?.map((elm) => ({
                              label: elm.routeNo,
                              value: JSON.stringify(elm),
                            }))}
                          />
                        </div>
                        <div className="flex flex-col w-[5%]" />
                        <div className="flex flex-col w-[48.5%]">
                          <p style={{ fontWeight: 500, marginBottom: "8px" }}>
                            Route 2
                          </p>
                          <Combobox
                            setValue={(e: string) => {
                              setSwapRouteB(e);
                              mergedTeam(swapRouteA, e);
                            }}
                            value={swapRouteB}
                            placeholder="Select Route"
                            data={routesToSwap?.map((elm) => ({
                              label: elm.routeNo,
                              value: JSON.stringify(elm),
                            }))}
                          />
                        </div>
                      </div>
                    </DialogDescription>
                  </DialogHeader>

                  {swapRouteA && swapRouteB && swapRouteA !== swapRouteB ? (
                    <KanbanBoard
                      key={`board-${swapRouteA ? JSON.parse(swapRouteA).routeNo : ""}-${swapRouteB ? JSON.parse(swapRouteB).routeNo : ""}`}
                      users={users}
                      cashCenterId={CashCenterId}
                      routeA={swapRouteA ? JSON.parse(swapRouteA) : {}}
                      routeB={swapRouteB ? JSON.parse(swapRouteB) : {}}
                      operationDate={formatDate(
                        operationDate || currentDate,
                        "yyyy-MM-dd'T'00:00:00.000'Z'",
                      )}
                      columnsRef={_swapColumnsRef}
                    />
                  ) : null}

                  {/* --- ROW 1: THE HEADERS --- */}
                  {/* Combobox A */}

                  {/* Combobox B */}
                </DialogContent>
              </Dialog>
              <Button
                variant="secondary"
                disabled={gettingRosterExport}
                onClick={() => {
                  exportRosters({
                    cashCenterId: CashCenterId,
                    operationDate: formatDate(
                      operationDate || currentDate,
                      "yyyy-MM-dd'T'00:00:00.000'Z'",
                    ),
                    pageNumber: currentPage,
                    pageRowCount: pageSize,
                    region: selectedRegion,
                    searchCriteria: filter.length >= 3 ? filter : "",
                  });
                }}
              >
                <FaFileExcel />
                <span className="ml-2">Export</span>
              </Button>
            </div>
          </div>
          <div className="flex flex-row gap-2 my-3">
            <div className="w-[20%]">
              <Combobox
                setValue={setSelectedCashCenter}
                value={selectedCashCenter}
                disabled={!Roles.includes("P&A Supervisor")}
                placeholder="Select Cash Center"
                data={
                  cashCenters?.map((elm) => ({
                    label: elm.name,
                    value: elm.cashCenterId,
                  })) || []
                }
              />
            </div>
            <div className="w-[20%]">
              <Combobox
                setValue={setSelectedRegion}
                value={selectedRegion}
                disabled={!Roles.includes("P&A Supervisor")}
                placeholder="Select Region"
                data={
                  regions?.map((elm: any) => ({
                    label: elm.name,
                    value: elm.name,
                  })) || []
                }
              />
            </div>
            <div className="w-[20%]">
              {" "}
              <DatePicker
                className="w-full"
                placeholder="Select Operation Date"
                selectedDate={operationDate}
                onSelectDate={onOperationDateChanged}
              />
            </div>

            <Input
              className="w-full ml-auto"
              value={filter}
              onChange={onFilterChange}
              placeholder="Search: RouteNo, Route Type, Van Registration No, Cash Box Serial, HHT Serial, Printer Serial"
            />
          </div>

          <ExcelExport
            ref={(exporter) => {
              excelExport2 = exporter;
            }}
            fileName={`Dispatch_Vehicles_${new Date().toDateString()}.xlsx`}
            columns={[
              { field: "rosterId", title: "Route Id" },
              { field: "routeNo", title: "Route No" },
              { field: "vanRegistrationNo", title: "Vehicle" },
              { field: "vanHandoverTime", title: "Van Handover Time" },
              { field: "startKilometer", title: "Start Kilometer" },
              { field: "remarks", title: "Remarks" },
            ]}
          />

          <ExcelExport
            ref={(exporter) => {
              excelExportReturn = exporter;
            }}
            fileName={`Return_Vehicles_${new Date().toDateString()}.xlsx`}
            columns={[
              { field: "rosterId", title: "Route Id" },
              { field: "routeNo", title: "Route No" },
              { field: "vanRegistrationNo", title: "Vehicle" },
              { field: "endKilometer", title: "End Kilometer" },
              { field: "returnDateTime", title: "Return Date Time" },
              { field: "remarks", title: "Remarks" },
            ]}
          />
          {loadingRequests ? (
            <div className="k-loading-mask">
              <span className="k-loading-text">Loading</span>
              <div className="k-loading-image" />
              <div className="k-loading-color" />
            </div>
          ) : null}
          <Grid
            data={process(teams, { ...dataState, skip: 0 })}
            sortable
            filterable
            {...dataState}
            onDataStateChange={(e) => {
              setDataState(e.dataState);
            }}
            pageable
            total={totalTeams}
            pageSize={pageSize}
            skip={(currentPage - 1) * pageSize}
            onPageChange={onPageChange}
          >
            <Column
              filterable={false}
              title="Route No."
              headerClassName="text-center"
              className="text-center"
              width={180}
              cell={editCell}
            />
            <Column field="cashCenter" title="Cash Center" width={160} />
            <Column field="routeType" title="Route Type" width={160} />

            <Column field="region" title="Region" width={160} />
            <Column
              field="busTime"
              title="Bus Time"
              width={100}
              headerClassName="text-center"
              className="text-center"
              cell={({ dataItem }) => {
                const time = dataItem?.busTime
                  ?.split("T")
                  .join(" ")
                  .replace("Z", "");
                if (time) {
                  return (
                    <td className="k-table-td text-center">
                      {moment(time, "YYYY-MM-DD HH:mm:ss").format("HH:mm")}
                    </td>
                  );
                }
                return <td />;
              }}
            />
            <Column
              field="routeTime"
              title="Route Time"
              width={120}
              headerClassName="text-center"
              className="text-center"
              cell={({ dataItem }) => {
                const time = dataItem?.routeTime
                  .split("T")
                  .join(" ")
                  .replace("Z", "");
                if (time) {
                  return (
                    <td className="k-table-td text-center">
                      {moment(time, "YYYY-MM-DD HH:mm:ss").format("HH:mm")}
                    </td>
                  );
                }
                return <td />;
              }}
            />
            <Column
              field="startKilometer"
              title="Start Kilometer"
              width={160}
            />
            <Column field="endKilometer" title="End Kilometer" width={160} />
            <Column
              field="cashBoxSerial"
              title="Cash Box Serial"
              width={160}
              headerClassName="text-center"
              className="text-center"
            />
            <Column
              field="hhtSerial"
              title="HHT Serial"
              width={100}
              headerClassName="text-center"
              className="text-center"
            />
            <Column
              field="printerSerial"
              title="Printer Serial"
              width={120}
              headerClassName="text-center"
              className="text-center"
            />

            <Column
              field="vanRegistrationNo"
              title="Van Registration No"
              width={160}
              headerClassName="text-center"
              className="text-center"
            />
            <Column
              field="vanHandoverTime"
              title="Van Handover Time"
              width={160}
              headerClassName="text-center"
              className="text-center"
              cell={({ dataItem }) => {
                const time = dataItem?.vanHandoverTime
                  ?.split("T")
                  .join(" ")
                  .replace("Z", "");
                if (time) {
                  return (
                    <td className="k-table-td text-center">
                      {moment(time, "YYYY-MM-DD HH:mm:ss").format("HH:mm")}
                    </td>
                  );
                }
                return <td />;
              }}
            />
            <Column
              field="vanReturnedTime"
              title="Van Returned Time"
              width={160}
              headerClassName="text-center"
              className="text-center"
              cell={({ dataItem }) => {
                const time = dataItem?.vanReturnedTime
                  ?.split("T")
                  .join(" ")
                  .replace("Z", "");
                if (time) {
                  return (
                    <td className="k-table-td text-center">
                      {moment(time, "YYYY-MM-DD HH:mm:ss").format("HH:mm")}
                    </td>
                  );
                }
                return <td />;
              }}
            />
            <Column field="requestedBy" title="Requested By" width={140} />

            <Column width={140} field="status" title="Status" />

            <Column
              filterable={false}
              title="Team"
              headerClassName="text-center"
              className="text-center"
              width={80}
              cell={viewTeamCell}
            />

            {/* <Column
              filterable={false}
              title="Team"
              headerClassName="text-center"
              className="text-center"
              width={80}
              cell={editRoster}
            /> */}

            <Column
              width="220"
              title="Update"
              className="text-center"
              filterable={false}
              cell={EditButtonCell}
            />
          </Grid>
        </CardContent>
      </Card>

      {/* Bulk Upload Dialog */}
      <Dialog open={openFileUpload} onOpenChange={setOpenFileUpload}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>
              {uploadMode === "issue"
                ? "Bulk Vehicle Issue"
                : "Bulk Vehicle Return"}
            </DialogTitle>
          </DialogHeader>
          <DialogDescription className="pt-6">
            {uploadedVehicles.length ? (
              <div className="flex flex-col items-center justify-center py-5">
                <p className="mb-4 text-gray-500">
                  {uploadedVehicles.length} row(s) parsed from file. Review and
                  click to confirm.
                </p>
                <div className="flex gap-2">
                  <Button
                    variant="secondary"
                    onClick={onConfirmVehicleUpload}
                    disabled={issueVanBulkLoading || returnVanBulkLoading}
                  >
                    {issueVanBulkLoading || returnVanBulkLoading
                      ? "Processing..."
                      : uploadMode === "issue"
                        ? "Issue Vans"
                        : "Return Vans"}
                  </Button>
                  <Button
                    variant="link"
                    onClick={() => {
                      setUploadedVehicles([]);
                      vehicleUploadList.current = [];
                    }}
                  >
                    Upload different file
                  </Button>
                </div>
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center w-full gap-4">
                <label
                  htmlFor="dropzone-file"
                  className="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
                >
                  <div className="flex flex-col items-center justify-center pt-5 pb-6">
                    <svg
                      className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 20 16"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                      />
                    </svg>
                    <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                      <span className="font-semibold">Click to upload</span> or
                      drag and drop
                    </p>
                  </div>
                  <input
                    id="dropzone-file"
                    accept=".xlsx, .xls, .csv"
                    type="file"
                    className="hidden"
                    onChange={fileHandler}
                  />
                </label>
              </div>
            )}
          </DialogDescription>
        </DialogContent>
      </Dialog>

      {/* Update/Single-record dialog (existing flow) */}
      <Dialog
        open={visible}
        onOpenChange={() => {
          toggleDialog();
        }}
      >
        <DialogContent
          onOpenAutoFocus={(e) => {
            e.preventDefault();
          }}
        >
          <DialogHeader>
            <DialogTitle>Update Van Status</DialogTitle>
          </DialogHeader>
          <DialogDescription>
            <label className="text-sm font-medium leading-none my-2 block">
              Route No
            </label>
            <Input value={team?.routeNo || ""} readOnly className="mb-2" />
            <label className="text-sm font-medium leading-none my-2 block">
              Select Vehicle
            </label>
            <Combobox
              placeholder="Select Vehicle"
              disabled={currentStatus === "Dispatched" && !isVehicleUpdate}
              data={
                vehicles?.map((item: { registrationNo: string }) => ({
                  label: item.registrationNo,
                  value: item.registrationNo,
                })) || []
              }
              value={ddlVehicles}
              setValue={setDdlVehicles}
            />
            {!isVehicleUpdate ? (
              <>
                <label className="text-sm font-medium leading-none my-2 block">
                  Status
                </label>
                <Select onValueChange={setDdlStatus} value={ddlStatus}>
                  <SelectTrigger className="w-full">
                    <SelectValue placeholder="Select Status" />
                  </SelectTrigger>
                  <SelectContent>
                    {statusList.map((item) => (
                      <SelectItem key={item.id} value={item.id}>
                        {item.text}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </>
            ) : null}
            {team?.status == "In Queue" ? (
              <>
                <div className="mt-3">
                  <label className="text-sm font-medium leading-none">
                    Start Kilometer
                  </label>
                  <NumericTextBox
                    step={0}
                    spinners={false}
                    min={0}
                    className="w-full h-10"
                    value={startKilometer}
                    onChange={(e) => {
                      setStartKilometer(e.target.value as any);
                    }}
                  />
                </div>
                <div className="mt-3">
                  <label className="text-sm font-medium leading-none mb-2 block">
                    Handover Date
                  </label>
                  <DateTimePicker
                    min={currentDate}
                    value={handoverDateTime}
                    className="w-full h-10"
                    onChange={(e) => {
                      onTxtHandoverDateChanged(e.target.value);
                    }}
                  />
                </div>
                <div className="mt-3">
                  <label className="text-sm font-medium leading-none mb-2 block">
                    Bus Date
                  </label>
                  <DateTimePicker
                    min={currentDate}
                    value={busDateTime}
                    className="w-full h-10"
                    onChange={(e) => {
                      onTxtBusDateChanged(e.target.value);
                    }}
                  />
                </div>
              </>
            ) : !isVehicleUpdate ? (
              <div className="mt-3">
                <label className="text-sm font-medium leading-none mb-2 block">
                  Return Date
                </label>
                <DateTimePicker
                  min={currentDate}
                  value={returnDateTime}
                  onChange={(e) => {
                    onTxtReturnDateChanged(e.target.value);
                  }}
                />
              </div>
            ) : null}
            <Textarea
              placeholder="Enter remarks"
              className="w-full mt-3"
              rows={3}
              value={remarks}
              onChange={(e) => {
                setRemarks(e.target.value);
              }}
            />
            <div className="mt-5">
              <Button
                variant="secondary"
                disabled={btnUpdateRecordDisabled}
                className="mx-auto w-50"
                onClick={onBtnUpdateRecordClicked}
              >
                {btnUpdateRecordText}
              </Button>
            </div>
          </DialogDescription>
        </DialogContent>
      </Dialog>

      {/* Checklist dialog */}

      <Dialog open={openEditModal} onOpenChange={setOpenEditModal}>
        <DialogContent
          className="max-w-[70vw] w-full"
          onOpenAutoFocus={(e) => {
            e.preventDefault();
          }}
          onInteractOutside={(e: any) => e.preventDefault()}
          onEscapeKeyDown={(e: any) => e.preventDefault()}
        >
          <DialogHeader>
            <DialogTitle>Edit Route</DialogTitle>
          </DialogHeader>
          <DialogDescription className="pt-4">
            <EditRoster
              route={selectedRoute}
              onRouteUpdated={() => {
                setOpenEditModal(false);
                refetchData();
              }}
            />
          </DialogDescription>
        </DialogContent>
      </Dialog>
      <ExcelExport
        data={exportRoutesList || []}
        fileName="Rosters.xlsx"
        ref={_rostersExport as any}
      >
        {routeListExportKeys.map((elm: any) => (
          <Column key={elm} field={elm} title={elm} />
        ))}
      </ExcelExport>
      {/* <ExcelExport
        data={
          exportRosterRes?.map((elm: any) => ({
            ...elm,
            busTime: elm.busTime
              ? moment(elm.busTime, "YYYY-MM-DD HH:mm:ss").format("HH:mm")
              : "",
            routeTime: elm.routeTime
              ? moment(elm.routeTime, "YYYY-MM-DD HH:mm:ss").format("HH:mm")
              : "",
            vanHandoverTime: elm.vanHandoverTime
              ? moment(elm.vanHandoverTime, "YYYY-MM-DD HH:mm:ss").format(
                  "HH:mm",
                )
              : "",
            vanReturnedTime: elm.vanReturnedTime
              ? moment(elm.vanReturnedTime, "YYYY-MM-DD HH:mm:ss").format(
                  "HH:mm",
                )
              : "",
          })) || []
        }
        fileName="Rosters.xlsx"
        ref={_rostersExport as any}
      >
        <Column field="cashCenter" title="Cash Center" width={160} />
        <Column field="routeType" title="Route Type" width={160} />
        <Column field="routeNo" title="Route No" width={120} />

        <Column field="region" title="Region" width={160} />
        <Column
          field="busTime"
          title="Bus Time"
          width={100}
          headerClassName="text-center"
          className="text-center"
        />
        <Column
          field="routeTime"
          title="Route Time"
          width={120}
          headerClassName="text-center"
          className="text-center"
        />
        <Column field="startKilometer" title="Start Kilometer" width={160} />
        <Column field="endKilometer" title="End Kilometer" width={160} />
        <Column
          field="cashBoxSerial"
          title="Cash Box Serial"
          width={160}
          headerClassName="text-center"
          className="text-center"
        />
        <Column
          field="hhtSerial"
          title="HHT Serial"
          width={100}
          headerClassName="text-center"
          className="text-center"
        />
        <Column
          field="printerSerial"
          title="Printer Serial"
          width={120}
          headerClassName="text-center"
          className="text-center"
        />

        <Column
          field="vanRegistrationNo"
          title="Van Registration No"
          width={160}
          headerClassName="text-center"
          className="text-center"
        />
        <Column
          field="vanHandoverTime"
          title="Van Handover Time"
          width={160}
          headerClassName="text-center"
          className="text-center"
        />
        <Column
          field="vanReturnedTime"
          title="Van Returned Time"
          width={160}
          headerClassName="text-center"
          className="text-center"
        />
        <Column field="requestedBy" title="Requested By" width={140} />

        <Column width={140} field="status" title="Status" />
      </ExcelExport> */}
    </Layout>
  );
}
